import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { dispatcher } from 'dispatcher';

import { JackpotWidget } from 'js/app/components/main/FeaturedBanner/components/FeaturedSlide/JackpotWidget';

import { getEnterDrawOptions, getSlideImage, useGetSlideOverride } from 'js/app/components/main/FeaturedBanner/components/FeaturedSlide/helpers';
import { useDetectImageColor } from 'js/app/hooks/useDetectImageColor';
import { clsx } from 'js/app/utils/clsx.util';
import { useDeltaChanged } from 'js/components/common/Slider/withSwipe/hooks';
import { useRunSlideAction } from 'js/components/main/Banner/components/Slide/hooks/useRunSlideAction';
import { useTranslations } from 'js/hooks/i18n';
import { useNavigate } from 'js/hooks/navigate';

import style from './FeaturedSlideMobile.scss';

export const FeaturedSlideMobile = ({ slide, index, bannerHeight, isCustomHeight }) => {
    const { pathname } = useLocation();
    const { terms, termsUrl, colorOverride, jackpotWidget } = slide;
    const translate = useTranslations('playtech.mobile.system.featuredbanner.');
    const deltaChanged = useDeltaChanged();
    const runSlideAction = useRunSlideAction(getEnterDrawOptions(slide), slide);
    const imageRef = useRef(null);
    const bottomColor = useDetectImageColor({ imageRef });
    const imagePath = getSlideImage(useGetSlideOverride(slide));
    const navigate = useNavigate();

    const handleClick = contentObj => () => !deltaChanged && runSlideAction(contentObj);
    const handleTermsLink = event => {
        if (!termsUrl?.length) {
            return;
        }

        event.stopPropagation();

        dispatcher.dispatch('bannerPosition', {
            page: pathname,
            action: 'termsLink',
            position: index + 1,
            link: termsUrl
        });

        navigate(termsUrl);
    };

    return (
        <div className={style.slide}>
            <div
                onClick={handleClick(slide)}
                className={style.content}
                style={{ backgroundColor: bottomColor }}
            >
                <div className={style.imgContainer}>
                    <img
                        style={{ height: bannerHeight }}
                        ref={imageRef}
                        src={imagePath}
                        className={clsx(style.image, { [style.isCustomHeight]: isCustomHeight })}
                        alt={translate('image.alt')}
                    />

                    {Boolean(jackpotWidget.jackpotCode) && (
                        <JackpotWidget options={jackpotWidget} />
                    )}
                </div>

                <div className={style.contentWrapper}>
                    <div className={style.textContent}>

                        {terms && (
                            <span
                                style={{ color: colorOverride }}
                                className={style.terms}
                                onClick={handleTermsLink}
                            >
                                {terms}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
